<div class="cardtext">{{task.summary || ('components.issuecard.titlePlaceholder' | translate)}}</div>
<div class="sticker-area">
    <span class="sticker-icon"
          *ngFor="let sticker of task.stickers"
          [attr.data-stickerId]="sticker.id"
          (click)="onStickerClicked($event,task,sticker)">

      <mat-icon *ngIf="sticker.iconName"
                [style.color]="sticker.iconColor"
                [attr.data-stickerId]="sticker.id">{{sticker.iconName}}
      </mat-icon>

      <img *ngIf="sticker.imageData"
           [src]="sticker.imageData" />
    </span>
</div>
<div class="avatar">
  <img *ngIf="task.assignee" class="avatar" [src]="'data:image/png;base64,'+ this.task.assignee.avatarImage">
  <i class = "material-icons" id="icon__placeholder" *ngIf="!task.assignee" >person</i>
</div>
